module.exports = __webpack_public_path__ + "img/37-l.f4fb09d8.png";